import Container from '../Container/Container';
import Section from '../Section/Section';
import type { JobDescriptionSectionProps } from './interfaces';
import styles from './JobDescriptionSection.module.scss';

const JobDescriptionSection = ({
  items,
  additionalInfo,
  hint,
  logoContainer,
  introduction,
}: JobDescriptionSectionProps) => {
  return (
    <Section>
      {logoContainer}
      <Container>
        {introduction}
        <div className={styles.jobDescriptionContainer}>
          {items.map((item, i) => {
            return (
              <div key={i} className={styles.jobDescriptionItem}>
                {item}
              </div>
            );
          })}
        </div>
        {hint}
        {additionalInfo && (
          <div className={styles.additionalInfo}>{additionalInfo}</div>
        )}
      </Container>
    </Section>
  );
};

export default JobDescriptionSection;
